/**
 * Change external URLs if variable is defined when building
 * @param url
 */
export function prefixedExternalUrl(url) {
  let finalUrl = EXTERNAL_URL_PREFIX && 'none' !== EXTERNAL_URL_PREFIX ? EXTERNAL_URL_PREFIX + url : url;
  // Debug url that will be opened
  console.debug('URL', url, 'rewritten to', finalUrl);
  return finalUrl;
}

/**
 * Used as central point to open links in new tabs or new webviews
 */
export default function fmExternalLink($window) {
  'ngInject';
  return {
    restrict: 'A',
    priority: 0,
    link: function (scope, element, attrs) {
      // Prevent default behavior and open links in a new tabs
      element.bind('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        // ng-href priority is 99, so href should be present at this time
        $window.open(prefixedExternalUrl(attrs.href), '_blank');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/directives/external-link.js